import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseAsyncValue } from '../../../shared/models/async-value';
import { getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

export class OneClickRequestedTimeProvider extends BaseAsyncValue<string> {
  getValue(): Observable<string> {
    const translate = this.injector.get<TranslateService>(TranslateService);
    const format = translate.instant('global.formatTime');
    return this.store.select(getOneClickSelectedOrder).pipe(
      filter(order => !!order && !!order.items && !!order.items.length),
      map(order => order.items[0]),
      map(item => {
        return moment(item.requestedDateTime).format(format);
      }),
    );
  }
}
